module.exports = __webpack_public_path__ + "static/media/inspector@2x.24683996.jpg";